import { useState } from "react";
import Avatar from "@mui/material/Avatar";
import profileImg from "../../image/Dr. Atun.png";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import Research from "../../components/research";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Marquee from "react-fast-marquee";
import Cards from "../../components/card";
import Card from "@mui/material/Card";
import CardActionArea from "@mui/material/CardActionArea";
import CardMedia from "@mui/material/CardMedia";
import "./home.css";
import "../../global.css";
import SwiperComp from "../../components/swiper/swiper";
import achivements from "./achivements";
import Metric from "../../components/metrics/metric";
import { certificates } from "./achivements";
function Home() {
  const navigate = useNavigate();
  const [visible, setVisible] = useState(false);
  const buttonHandle = () => {
    setVisible(!visible);
    // window.location = "/about";
  };
  console.log(" cert", certificates[0]);
  return (
    <>
      <Box
        display="flex"
        // flexDirection={"row"}
        // gap={9}
        sx={{
          paddingTop: "1%",
          justifyContent: "space-around",
          flexDirection: { xs: "column", md: "row" },
          alignItems: { xs: "center", md: "flex-start" },
          gap: "5%",
        }}
      >
        <Avatar
          alt="profile"
          src={profileImg}
          sx={{
            width: { xs: 120, md: 250 },
            height: { xs: 120, md: 250 },
            ml: "12px",
            "& img": {
              width: "100%",
              height: "100%",
              objectFit: "cover",
            },
          }}
        />
        <Box
          display="flex"
          flexDirection={"column"}
          sx={{ alignItems: { xs: "center", md: "start" } }}
        >
          <Typography
            // textAlign={"left"}
            sx={{
              fontSize: { xs: "2rem", md: "3rem" },
              textAlign: { xs: "center", md: "left" },
            }}
          >
            Dr. Atun Roy Choudhury
          </Typography>
          <Box sx={{ border: "1px solid black", width: "120px" }} />
          <Typography
            textAlign={"justify"}
            // paddingTop={1}
            // paddingBottom={1}
            fontWeight={300}
            sx={{
              fontSize: { xs: "1rem", md: "1.25rem" },
              padding: { xs: "8px", md: "8px 0" },
            }}
          >
            {" "}
            Dr. Atun Roy Choudhury is an Environmental Engineer with a PhD from
            BITS Pilani and currently serves as Technical Head at Unison i3x. He
            has held key roles across leading organizations including IL&FS
            Environment, Ramky Enviro Engineers Ltd., Banka Bio, Shrushti Group,
            and Cube Bio. His core expertise includes waste management, waste
            valorization, air pollution control, water, and sanitation systems.
            {visible && (
              <span>
                {"  "} He has authored over 60 publications in reputed
                international journals, books, and scientific magazines and
                serves as an Editor and Reviewer for leading publishers such as
                Nature, Oxford Academic, Elsevier, Springer, PLOS, etc. His
                expert views have been featured in national newspapers and
                magazines, and he is a frequent speaker at national and
                international forums, including TEDx. Dr. Choudhury is a
                recipient of the UGC Gold Medal and holds certifications as an
                Environmental Lead Auditor. His patented work on waste
                valorization has received recognition from the United Nations,
                the Government of India under the KAPILA scheme, and the India
                Book of Records. He has also been featured in the Oxford World
                Book of Researchers. He continues to contribute to sustainable
                environmental solutions through the integration of research,
                industry practice, and innovation.
              </span>
            )}
          </Typography>
          <Button
            variant="contained"
            sx={{ whiteSpace: "nowrap", width: "fit-content" }}
            marginTop={1}
            onClick={buttonHandle}
          >
            {visible ? "READ LESS" : "READ MORE"}
          </Button>
        </Box>
        <Box
          display="flex"
          flexDirection="column"
          gap={"20px"}
          // width={"30%"}
          padding={"0 1% 0 0"}
          sx={{ marginTop: { xs: "1rem", md: "0" } }}
        >
          <Box
            display="flex"
            gap={"9px"}
            padding={"10px 0"}
            sx={{ justifyContent: { xs: "center", md: "flex-start" } }}
          >
            <Typography sx={{ fontSize: { xs: "1.25rem", md: "1.5rem" } }}>
              UPCOMING{" "}
            </Typography>
            <Typography
              variant="h5"
              sx={{
                color: "#d32f2f",
                fontSize: { xs: "1.25rem", md: "1.5rem" },
              }}
            >
              EVENTS
            </Typography>
            <CalendarMonthIcon />
            <Link to={"/about/upcoming_events"}>
              <Button
                variant="contained"
                color="error"
                sx={{ whiteSpace: "nowrap" }}
              >
                VIEW ALL
              </Button>
            </Link>
          </Box>
          <Typography>PROGRAMS ON PLATTER</Typography>
          <div className="divider" style={{ width: "98%" }} />
          <Typography>
            Sharing innovative ideas and driving impactful conversations at
            events that shape the future of sustainability
          </Typography>
          <iframe
            src="https://res.cloudinary.com/dc784nwli/video/upload/v1753525980/Dr._Atun_Roy_Choudhury_Video_tqfavv.mp4"
            frameborder="0"
            allow="autoplay; encrypted-media"
            allowFullScreen
            title="video"
            style={{ width: "100%", height: "200px" }}
          />
        </Box>
      </Box>
      <div className="page-container">
        {/* <p>This is home page</p> */}

        {/* <Research /> */}
        <SwiperComp achivements={achivements} />
        {/* <Marquee></Marquee> */}
        <Link to="https://drive.google.com/file/d/127RJ7IvZbS3-ZY2emyiGhBgCfEgg6-5c/view?usp=sharing">
          <Button
            variant="contained"
            sx={{ height: "45px", fontSize: "large" }}
          >
            Download Full CV
          </Button>
        </Link>
        {/* <Metric /> */}
      </div>
      <div className="metric">
        <Metric />
      </div>
      <div style={{ marginTop: "40px" }}>
        <Marquee pauseOnHover>
          {certificates.map((images) => (
            // <Cards
            //   url={images.url}
            //   width="95%"
            //   height="350"
            //   sx={{ padding: "0 5px" }}
            // />
            <Card
              sx={{
                width: "95%",
                height: 350,
                position: "relative",
              }}
            >
              <CardActionArea>
                <CardMedia
                  component="img"
                  height={350}
                  image={images.url}
                  alt="certificate"
                  className="image-zoom"
                />
              </CardActionArea>
            </Card>
          ))}
        </Marquee>
      </div>
    </>
  );
}

export default Home;
